import React from 'react';

export const TrashWhiteBackgroundIcon = (): JSX.Element => {
  const holder =
    'M13 10V8C13 7.46957 13.2107 6.96086 13.5858 6.58579C13.9609 6.21071 ' +
    '14.4696 6 15 6H19C19.5304 6 20.0391 6.21071 20.4142 6.58579C20.7893 ' +
    '6.96086 21 7.46957 21 8V10M24 10V24C24 24.5304 23.7893 25.0391 23.4142 ' +
    '25.4142C23.0391 25.7893 22.5304 26 22 26H12C11.4696 26 10.9609 25.7893 10.5858 ' +
    ' 25.4142C10.2107 25.0391 10 24.5304 10 24V10H24Z';

  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.5" cy="16.5" r="16.5" fill="white" />
      <path
        d="M8 10H10H26"
        stroke="#0193E5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={holder}
        stroke="#0193E5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15V21"
        stroke="#0193E5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 15V21"
        stroke="#0193E5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
